// ** Third Party Imports
import styled, { type CSSProperties } from 'styled-components'

// ** Component Imports
import { Typography } from '@/shared/ui/elements/Typography'

// ** Icon Imports
import { Check, CheckSquare, Square } from '@/shared/ui/icons'

export const Container = styled.div`
	position: relative;
`

export const Label = styled.label<{
	$isError: boolean
	$isSuccess: boolean
	$isFloating: boolean
	$isDisabled: boolean
	$styles: CSSProperties
}>`
	top: 50%;
	left: 0.75rem;
	color: ${({ theme }) => theme.pallette.text.black50};
	z-index: 2;
	position: absolute;
	transform: translateY(-50%);
	font-size: 0.875rem;
	transition: 0.3s ease all;
	font-weight: 400;
	background-color: ${({ theme }) => theme.pallette.geniiWhite};
	pointer-events: none;
	max-width: 70%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	${({ theme, $isFloating }) =>
		$isFloating &&
		`
      top: 0;
      left: 0.75rem;
      padding: 0 0.25rem;
      font-size: 0.625rem;
      color: ${theme.pallette.text.black75};
  `}

	${({ theme, $isSuccess }) =>
		$isSuccess && `color: ${theme.pallette.success.main};`}

	${({ theme, $isError }) => $isError && `color: ${theme.pallette.error.main};`}

  ${({ $isDisabled }) => $isDisabled && `color: rgba(132, 136, 152, 0.5);`}

  ${({ $isSuccess, $isDisabled }) =>
		$isSuccess && $isDisabled && `color: rgba(126, 173, 130, 0.5);`}

  ${({ $styles }) => ({ ...$styles })}
`

export const StyledOption = styled.div`
	color: ${({ theme }) => theme.pallette.text.black75};
	cursor: pointer;
	display: flex;
	outline: none;
	align-items: center;
	background-color: transparent;

	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.pallette.text.black50};
	}

	&:hover {
		background-color: ${({ theme }) =>
			theme.pallette.primary.greenBackground60};
	}

	/* Disable native background on item first click */
	& > div:active {
		background-color: transparent;
	}

	& > div[aria-disabled='true'] {
		cursor: not-allowed;
		opacity: 0.5;
		pointer-events: none;
		color: ${({ theme }) => theme.pallette.text.black50};
		background-color: transparent;
	}

	/* prevent hover highlight when disabled */
	&:has(> div[aria-disabled='true']):hover {
		background-color: transparent;
		cursor: not-allowed;
	}
`

export const CheckIcon = styled(Check)`
	margin-right: 0.75rem;

	path {
		stroke: ${({ theme }) => theme.pallette.success.main};
	}
`

export const SquareIcon = styled(Square)`
	margin-left: 0.75rem;

	& path {
		stroke: ${({ theme }) => theme.pallette.text.black75};
	}
`

export const CheckSquareIcon = styled(CheckSquare)`
	margin-left: 0.75rem;

	& path {
		stroke: ${({ theme }) => theme.pallette.success.main};
	}
`

export const MoreText = styled(Typography)`
	color: ${({ theme }) => theme.pallette.text.black75};
	margin-left: auto;
	white-space: nowrap;
`
